$(document).ready(function () {
    // Variables
    const $searchInput = $("#newSearchInput");
    const $searchResultsBox = $(".seachResultBox");
    const $searchResultsList = $(".searchResultUl");
    const $searchGridContainer = $("#search-results .row");
    const $clearButton = $("#clearSearch");
    const $searchSuggestions = $(".search-suggestions");
    const $searchPageProducts = $(".search-page-products");
    const $noResultsWrapper = $(".no-search-results");
    const $minRange = $("#minRange");
    const $maxRange = $("#maxRange");
    const $minValue = $("#minValue");
    const $maxValue = $("#maxValue");
    const $track = $(".slider .track");
    const $sliderContainer = $(".slider");
    const $tabContainer = $("#tabContainer");

    // Utility: Format currency
    function formatCurrency(value) {
        return `$${Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    }
    
    let isProgrammaticInputValue = false;

    // Search functionality
    $searchInput.on("input", function () {
        const query = $searchInput.val().trim();
        if (query.length > 2) 
        {
            $.ajax({
                url: "https://damaciitemplates.myshopify.com/api/2023-01/graphql.json",
                type: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": "ec8c4f6ded97cea3762b814f32ab8258"
                },
                data: JSON.stringify({
                    query: `
                    {
                      products(first: 20, query: "title:${query}") {
                        edges {
                          node {
                            id
                            title
                            handle
                            featuredImage {
                              url
                              altText
                            }
                            variants(first: 5) {
                              edges {
                                node {
                                  id
                                  price: priceV2 {
                                    amount
                                    currencyCode
                                  }
                                  selectedOptions {
                                    name
                                    value
                                  }
                                }
                              }
                            }
                            colors: metafield(
                                namespace: "custom"
                                key: "color"
                            ) {
                                value
                            }
                          }
                        }
                      }
                    }
                    `
                }),
                success: function (response) {
                    console.log(response)
                    const products = response.data.products.edges.map(edge => edge.node);
                    const productCount = products.length;
                    $(".productCount").text(productCount);

                    if (productCount > 0) {
                        $noResultsWrapper.empty().hide();
                        $searchPageProducts.hide();
                        $searchSuggestions.show();
                        if(!isProgrammaticInputValue)
                        {
                           $searchResultsBox.show();
                        }
                        renderSearchResults(products);
                        initializePriceSlider();
                        initializeColorFilter();
                        setTimeout(() => {
                          isProgrammaticInputValue = false;
                        }, 0);
                    } else {
                        showNoResults(query);
                    }
                },
                error: function (error) {
                    console.error(error);
                }
            });
        } 
        else
        {
          $searchPageProducts.show();
          $searchSuggestions.hide();
          $searchResultsBox.hide();
          $searchGridContainer.empty();
          $noResultsWrapper.empty().hide();
          $(".productCount").text("");
          $(".tab-button").removeClass("active");
        }
    });

    function renderSearchResults(products) {
        // Populate suggestions
        const suggestionsHtml = products.map(product => `
            <li>
                <a href="/products/${product.handle}" class="wishlist-icon">
                    <img src="https://cdn.shopify.com/s/files/1/0911/5002/5007/files/search-interface-symbol.png?v=1736532014" alt="search icon" class="img-fluid">
                    <span>${product.title}</span>
                </a>
            </li>`).join("");
        $searchResultsList.html(suggestionsHtml);

        // Populate product grid
        const gridHtml = products.map(product => {
            let colors = '';
            const colors_string = product.colors ? product.colors.value : "Unknown";
            if(colors_string != 'Unknown' )
            {
              const colors_array = JSON.parse(colors_string);
              colors = colors_array.join(",");
            }
            else
            {
              colors = 'Unknown';
            }

            const price = product.variants.edges[0]?.node.price.amount || "N/A";
            const imageUrl = product.featuredImage?.url || "placeholder.jpg";
            const imageAlt = product.featuredImage?.altText || "Product image";

            return `
            <div class="col-lg-2 col-md-3 col-sm-6 col-6 noPad product" 
                data-color="${colors}" data-price="${price}">
                <div class="ProdGallryInner">
                    <div class="prodGallerImage">
                        <div class="image-zoom-wrapper">
                            <img src="${imageUrl}" alt="${imageAlt}" class="img-fluid zoomable-image" />
                        </div>
                        <a href="/products/${product.handle}" class="wishlist-icon">
                           <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 117 117" fill="none">
                                <path d="M82.2656 14.625C74.9531 14.625 68.0062 17.55 62.8875 22.6687L58.4999 27.0563L54.4781 23.0344C43.8749 12.0656 26.325 12.0656 15.7218 22.6687L15.3562 23.0344C4.38745 34.0031 4.38745 51.5531 15.3562 62.5219L58.4999 106.031L101.644 62.5219C112.612 51.5531 112.612 34.0031 101.644 23.0344C96.5249 17.55 89.5781 14.625 82.2656 14.625Z" 
                                    fill="none" 
                                    stroke="black" 
                                    stroke-width="10" />
                            </svg>
                        </a> 
                    </div>
                    <div class="proGalleryContent">
                        <a href="/products/${product.handle}">${product.title}</a>
                        <p>${formatCurrency(price)}</p>
                    </div>
                </div>
            </div>`;
        }).join("");
        $searchGridContainer.html(gridHtml);
    }

    // Reset search
    $clearButton.on("click", resetSearch);

    function resetSearch() {
        $searchInput.val("");
        $searchPageProducts.show();
        $searchSuggestions.hide();
        $searchResultsBox.hide();
        $searchGridContainer.empty();
        $noResultsWrapper.empty().hide();
        $(".productCount").text("");
        $(".tab-button").removeClass("active");
    }

    function showNoResults(query) {
        $searchPageProducts.show();
        $searchSuggestions.hide();
        $searchResultsBox.hide();
        $searchGridContainer.html("<p>No results found</p>");
        $noResultsWrapper.html(`
            <p class="text-center pt-2">No results were found for the keyword "${query}"</p>
            <p class="text-center">To improve your results, check your spelling or use a more general keyword.</p>
        `).show();
    }

    // Dynamic tabs
    const tabData = [
        { label: "jacket", active: false },
        { label: "mens", active: false },
        { label: "womens", active: false },
        { label: "handbag", active: false },
        { label: "backpack", active: false },
    ];

    tabData.forEach(tab => {
        const $tabItem = $("<li>");
        const $button = $(`<button class="tab-button ${tab.active ? "active" : ""}">${tab.label}</button>`);
        
        $button.on("click", function () {
            isProgrammaticInputValue = true;
            $(".tab-button").removeClass("active");
            $button.addClass("active");
            $searchInput.val(tab.label).trigger("input");
        });

        $tabItem.append($button);
        $tabContainer.append($tabItem);
    });

    // Hide suggestions when clicking outside
    $(document).on("click", function (event) {
        if (!$searchResultsBox.is(event.target) && !$searchResultsBox.has(event.target).length && !$searchInput.is(event.target)) {
            $searchResultsBox.hide();
        }
    });

    // Price slider
    function initializePriceSlider() {
        const $products = $(".product");
        if ($products.length === 0) return;

        const prices = $products.map(function () {
            return parseFloat($(this).data("price"));
        }).get();

        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);

        $minRange.attr({ min: minPrice, max: maxPrice }).val(minPrice);
        $maxRange.attr({ min: minPrice, max: maxPrice }).val(maxPrice);
        $minValue.text(formatCurrency(minPrice));
        $maxValue.text(formatCurrency(maxPrice));

        filterPrice();
    }

    function filterPrice() {
        const $products = $(".product");
        if ($products.length === 0) return;

        const minVal = parseFloat($minRange.val());
        const maxVal = parseFloat($maxRange.val());
        $minValue.text(formatCurrency(minVal));
        $maxValue.text(formatCurrency(maxVal));

        const minPercent = ((minVal - parseFloat($minRange.attr("min"))) /
                            (parseFloat($minRange.attr("max")) - parseFloat($minRange.attr("min")))) * 100;
        const maxPercent = ((maxVal - parseFloat($maxRange.attr("min"))) /
                            (parseFloat($maxRange.attr("max")) - parseFloat($maxRange.attr("min")))) * 100;

        $track.css({ left: `${minPercent}%`, right: `${100 - maxPercent}%` });

        let count = 0;
        $products.each(function () {
            const price = parseFloat($(this).data("price"));
            if (price >= minVal && price <= maxVal) {
                $(this).show();
                count++;
            } else {
                $(this).hide();
            }
        });
        $(".productCount").text(count);
    }

    $minRange.on("input", filterPrice);
    $maxRange.on("input", filterPrice);

    // Sidebar and accordion
    $("#openSidebar").on("click", () => $("body").addClass("sidebar-open"));
    $(".closeSidebar").on("click", () => $("body").removeClass("sidebar-open"));

    $(".accordion-header").on("click", function () {
        $(this).toggleClass("active").next().css("max-height", function () {
            return $(this).prev().hasClass("active") ? `${$(this).prop("scrollHeight")}px` : "0";
        });
    });

    // Section toggle
    $("#toggleButton").on("click", () => $("body").addClass("section-active").find(".sectionOverlay").addClass("activeSerach"));
    $("#crossIconSerch").on("click", () => $("body").removeClass("section-active").find(".sectionOverlay").removeClass("activeSerach"));

    // Initialize color filter
    function initializeColorFilter() {
        const $colorBoxes = $(".colorBoxFilter");
        const $products = $(".product");
    
        // Click event on color boxes
        $colorBoxes.on("click", function () {
            const selectedColor = $(this).find(".colorName").text().trim().toLowerCase();
            let colorCount = 0;
            console.log(selectedColor)
    
            // Highlight the selected color box
            $colorBoxes.removeClass("selected");
            $(this).addClass("selected");
    
            // Filter products based on the selected color
            $(".product").each(function () {
              const productColors = $(this).data("color").toLowerCase().split(","); // Get product colors as an array
              
              console.log(productColors)
        
              if (productColors.includes(selectedColor)) {
                colorCount++;
                $(this).show(); // Show product if it contains the selected color
              } else {
                $(this).hide(); // Hide product if it doesn't match
              }
            });
            $(".productCount").text(colorCount);
        });
    
        // Clear color filter on a reset button click
        $("#clearColorFilter").on("click", function () {
            $colorBoxes.removeClass("selected");
            $products.show();
        });
    }
});


